module.exports = __webpack_public_path__ + "static/foodstandslide-14-min-74ad98f1dc794806ca4608119f17bb5d.jpg";